// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__iQZGB","topBottomGutter":"Layout_topBottomGutter__uFLs_"};